var exports = {
  "r4": "filterLink__ywNfwR",
  "Qj": "assigneeFilterButton__qjUOpY",
  "ah": "authorLink__jEE_DC",
  "CB": "subIssuesProgressCircle__kI09aN",
  "Az": "blockedToken__Wp7ahS",
  "tJ": "metadataContainer__NZBoVo",
  "c7": "metadataCell__b4mKQc",
  "SY": "compactDescription__kAWlWc",
};

module.exports = exports;
